import React from 'react';
import { MessageCircle, Mail, MapPin } from 'lucide-react';
import { whatsappNumber } from '../data/mockData';
import { useLanguage } from '../contexts/LanguageContext';

export const Footer = () => {
  const currentYear = new Date().getFullYear();
  const { t } = useLanguage();

  const handleWhatsAppClick = () => {
    const message = encodeURIComponent(t('whatsappGeneric'));
    window.open(`https://wa.me/${whatsappNumber}?text=${message}`, '_blank');
  };

  return (
    <footer className="site-footer">
      <div className="footer-container">
        <div className="footer-grid">
          <div className="footer-column">
            <div className="footer-logo">
              <svg width="32" height="32" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="20" cy="20" r="19" stroke="currentColor" strokeWidth="1.5" fill="none" opacity="0.3"/>
                <path d="M16 14 C16 14, 18 10, 22 10 C26 10, 28 12, 28 16 C28 18, 26 20, 24 20" stroke="currentColor" strokeWidth="1.5" fill="none" strokeLinecap="round"/>
                <path d="M24 20 C24 20, 24 22, 24 24 C24 26, 22 28, 20 28 C18 28, 16 26, 16 24 L16 14" stroke="currentColor" strokeWidth="1.5" fill="none" strokeLinecap="round"/>
                <circle cx="22" cy="16" r="1" fill="currentColor"/>
                <path d="M22 18 L22 22" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
                <path d="M14 22 C14 22, 16 24, 18 24" stroke="currentColor" strokeWidth="1" strokeLinecap="round" opacity="0.6"/>
                <path d="M20 10 C20 10, 22 8, 24 8" stroke="currentColor" strokeWidth="1" strokeLinecap="round" opacity="0.4"/>
              </svg>
              <span>Villa in Pietra</span>
            </div>
            <p className="footer-description">{t('footer.description')}</p>
          </div>

          <div className="footer-column">
            <h3 className="footer-heading">{t('footer.contact')}</h3>
            <div className="footer-links">
              <button onClick={handleWhatsAppClick} className="footer-contact-item">
                <MessageCircle className="h-4 w-4" />
                <span>{t('footer.whatsappLabel')} {whatsappNumber}</span>
              </button>
              <div className="footer-contact-item">
                <MapPin className="h-4 w-4" />
                <span>Bajkini, Istria, Croatia</span>
              </div>
              <div className="footer-contact-item">
                <Mail className="h-4 w-4" />
                <span>{t('footer.availableWhatsApp')}</span>
              </div>
            </div>
          </div>

          <div className="footer-column">
            <h3 className="footer-heading">{t('footer.quickLinks')}</h3>
            <div className="footer-links">
              <a href="#highlights" className="footer-link">{t('footer.villaHighlights')}</a>
              <a href="#location" className="footer-link">{t('footer.locationArea')}</a>
              <a href="#amenities" className="footer-link">{t('footer.amenities')}</a>
              <a href="#reviews" className="footer-link">{t('footer.guestReviews')}</a>
              <a href="#booking" className="footer-link">{t('footer.checkAvailability')}</a>
            </div>
          </div>

          <div className="footer-column">
            <h3 className="footer-heading">{t('footer.propertyDetails')}</h3>
            <div className="footer-info-list">
              <p>{t('footer.propGuests')}</p>
              <p>{t('footer.propBedrooms')}</p>
              <p>{t('footer.propPool')}</p>
              <p>{t('footer.propEstate')}</p>
              <p>{t('footer.propMinStay')}</p>
              <p>{t('footer.propDeposit')}</p>
            </div>
          </div>
        </div>

        <div className="footer-divider"></div>

        <div className="footer-bottom">
          <p className="footer-copyright">
            {t('footer.copyright').replace('{year}', currentYear)}
          </p>
          <div className="footer-bottom-links">
            <span className="footer-managed">
              {t('footer.managedBy')} <strong>La Vita Estate</strong> Real Estate Agency
            </span>
          </div>
        </div>
      </div>

      <button
        onClick={handleWhatsAppClick}
        className="floating-whatsapp-button"
        aria-label="Contact via WhatsApp"
        data-testid="floating-whatsapp"
      >
        <MessageCircle className="h-6 w-6" />
      </button>
    </footer>
  );
};
